// client/src/components/BidEstimation/Documents/documentDisplay.js
// Shared display helpers for the Documents panel — used by DocumentsSection
// and DocumentRow.
import React from 'react'
import {
  PictureAsPdf,
  Description as DescriptionIcon,
  InsertDriveFile,
  Image as ImageIcon
} from '@material-ui/icons'

const formatBytes = (bytes) => {
  if (!bytes && bytes !== 0) return ''
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`
}

const formatDate = (dateStr) => {
  if (!dateStr) return ''
  try {
    return new Date(dateStr).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    })
  } catch (e) {
    return ''
  }
}

const iconForFileType = (fileType) => {
  switch ((fileType || '').toLowerCase()) {
    case 'pdf':
      return <PictureAsPdf style={{ color: '#d32f2f', fontSize: 32 }} />
    case 'xlsx':
    case 'xls':
    case 'csv':
      return <DescriptionIcon style={{ color: '#2e7d32', fontSize: 32 }} />
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
      return <ImageIcon style={{ color: '#1976d2', fontSize: 32 }} />
    default:
      return <InsertDriveFile style={{ color: '#757575', fontSize: 32 }} />
  }
}

const parseStatusChip = (status) => {
  switch (status) {
    case 'parsed':
      return { label: 'Parsed', style: { backgroundColor: '#c8e6c9', color: '#2e7d32' } }
    case 'classified':
      return { label: 'Plan Set — Select Pages', style: { backgroundColor: '#e3f2fd', color: '#1565c0' } }
    case 'failed':
      return { label: 'Parse failed', style: { backgroundColor: '#ffcdd2', color: '#c62828' } }
    case 'unsupported':
      return { label: 'Unsupported', style: { backgroundColor: '#eeeeee', color: '#616161' } }
    case 'pending':
      return { label: 'Parsing…', style: { backgroundColor: '#fff9c4', color: '#f57f17' } }
    case 'not_attempted':
    default:
      return { label: 'Saved', style: { backgroundColor: '#f5f5f5', color: '#757575' } }
  }
}

const getDocumentPageMetrics = (doc) => {
  const pageSummary = doc && doc.pageSummary
  if (pageSummary && Number.isFinite(Number(pageSummary.totalPages))) {
    return {
      totalPages: Number(pageSummary.totalPages || 0),
      schedulePages: Number(pageSummary.schedulePages || 0)
    }
  }
  const sheetIndex = doc && doc.parseResult && Array.isArray(doc.parseResult.sheetIndex) ? doc.parseResult.sheetIndex : []
  return {
    totalPages: sheetIndex.length,
    schedulePages: sheetIndex.filter(s => s.hasSchedule).length
  }
}

const CATEGORY_CHIP = {
  plans:          { label: 'Plans',          bg: 'var(--info-tint, #e3f2fd)',     color: 'var(--info, #1565c0)' },
  bid_response:   { label: 'Bid Response',   bg: 'var(--accent-tint, #fff3e0)',   color: 'var(--accent, #e65100)' },
  vendor_quote:   { label: 'Vendor Quote',   bg: 'var(--ok-tint, #e8f5e9)',       color: 'var(--ok, #2e7d32)' },
  vendor_invoice: { label: 'Vendor Invoice', bg: 'var(--ok-tint, #e8f5e9)',       color: 'var(--ok, #2e7d32)' },
  photos:         { label: 'Photos',         bg: 'rgba(123, 31, 162, 0.12)',      color: '#7b1fa2' },
  signed_estimate:{ label: 'Signed Estimate',bg: 'rgba(0, 131, 143, 0.12)',       color: '#00838f' },
  rfp_details:    { label: 'RFP Details',    bg: 'rgba(106, 27, 154, 0.12)',      color: '#6a1b9a' },
  files:          { label: 'Other Files',    bg: '#eceff1',                       color: '#546e7a' },
  other:          { label: 'Other',          bg: '#eeeeee',                       color: '#616161' }
}

export {
  formatBytes,
  formatDate,
  iconForFileType,
  parseStatusChip,
  getDocumentPageMetrics,
  CATEGORY_CHIP
}
